import Vue from 'vue'
import VueRouter from 'vue-router'

//page
import Home from '@/components/pages/Home/index'
import Rbcn from '@/components/pages/Rbcn/index'
import Rbcnsystem from '@/components/pages/Rbcnsystem/index'
import Platformlobby from '@/components/pages/Platformlobby/index'
import PlatformShow from '@/components/pages/PlatformShow/index'
import Rblt from '@/components/pages/Rblt/index'
import Gamelobby from '@/components/pages/Gamelobby/index'
import Develop from '@/components/pages/Develop/index'
import Payment from '@/components/pages/Payment/index'
import Experience from '@/components/pages/Experience/index'
import Platform from '@/components/pages/Platform/index'
import Support from '@/components/pages/Support/index'
// import News from '@/components/pages/News/index'
// import Newsdetail from '@/components/pages/Newsdetail/index'
import Page2019 from '@/components/pages/2019Page/index'
import G2EAsia2018 from '@/components/pages/G2EAsia2018/index'
import G2EAsia2017 from '@/components/pages/G2EAsia2017/index'
import Contact from '@/components/pages/Contact/index'

Vue.use(VueRouter)

const router = new VueRouter({
  base: __dirname,
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home,
    },
    {
      path: '/rbcn',
      name: 'rbcn',
      component: Rbcn,
    },
    {
      path: '/rbcnsystem',
      name: 'rbcnsystem',
      component: Rbcnsystem,
    },
    {
      path: '/platformlobby',
      redirect: {name: 'platformlobby', params: {name: 'pc'}}
    },
    // 圖檔尚未完整，先不開放訪問
    // {
    //   path: '/platformlobby/mb',
    //   redirect: {name: 'platformlobby', params: {name: 'pc'}}
    // },
    {
      path: '/platformlobby/:name',
      name: 'platformlobby',
      component: Platformlobby,
    },
    // 圖檔尚未完整，先不開放訪問
    // {
    //   path: '/platformShow/mb/:id',
    //   redirect: {name: 'platformShow', params: {name: 'pc', id: '6'}}
    // },
    {
      path: '/platformShow/:name/:id',
      name: 'platformShow',
      component: PlatformShow,
    },
    {
      path: '/rblt',
      name: 'rblt',
      component: Rblt,
    },
    {
      path: '/gamelobby',
      name: 'gamelobby',
      component: Gamelobby,
    },
    {
      path: '/develop',
      name: 'develop',
      component: Develop,
    },
    {
      path: '/develop/:name',
      name: 'developDetial',
      component: Develop,
    },
    {
      path: '/payment',
      name: 'payment',
      component: Payment,
    },
    {
      path: '/experience',
      name: 'experience',
      component: Experience,
    },
    {
      path: '/platform/:name',
      name: 'platform',
      component: Platform,
    },
    {
      path: '/support/:name',
      name: 'support',
      component: Support,
    },
    // {
    //   path: '/news',
    //   name: 'news',
    //   component:  News
    // },
    // {
    //   path: '/newsdetail/:id',
    //   name: 'newsdetail',
    //   component:  Newsdetail
    // },
    {
      path: '/2019Page',
      name: '2019Page',
      component: Page2019,
    },
    {
      path: '/G2EAsia2018',
      name: 'G2EAsia2018',
      component: G2EAsia2018,
    },
    {
      path: '/G2EAsia2017',
      name: 'G2EAsia2017',
      component: G2EAsia2017,
    },
    {
      path: '/contact',
      name: 'contact',
      component: Contact,
    },
  ],
})

router.beforeEach((to, from, next) => {
  if (to.matched.length === 0) {
    next('/')
  } else {
    next()
  }
})

export default router
